var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Icon",class:{
    'Icon--circle' : _vm.circle
  },style:(("font-size:" + (_vm.size / 2) + "px"))},[_c('img',{attrs:{"src":_vm.src}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }